import Vue from 'vue'
import {buildMenu} from '@azinformatica/loki'
import RootPage from '@/views/pages/RootPage.vue'
import router from '@/views/routers'
import store from '@/core/store'
import exceptionHandler from '@/core/exceptions/ExceptionHandler'
import i18n from '@/i18n'
import {actionTypes, mutationTypes} from '@/core/constants'

class RootPageCreator {
    
    async createInstance(){
        await this._resolverDependencias()
        this.instanciar()
    }
    
    async _resolverDependencias() {
        await this._buscarParametrosSistema()
    }
    
    async _buscarParametrosSistema() {
        await store.dispatch(actionTypes.BUSCAR_PARAMETROS)
    }
    
    instanciar() {
        new Vue({
            i18n,
            router,
            store,
            render: h => h(RootPage),
            created() {
                this.$store.commit('SET_MENU_ACTIONS', buildMenu(store, router))
                this.$vuetify.theme.primary = store.state.tema.primary
                this.$vuetify.theme.secondary = store.state.tema.secondary
                this.$store.commit(mutationTypes.LOKI.SET_FILES_API, this.$store.state.file)
                this.$store.commit(mutationTypes.LOKI.SET_TIMEZONE, this.$store.state.parametros.timezone)
            },
            errorCaptured(error) {
                exceptionHandler.execute(error)
                return false
            }
        }).$mount('#app')
    }

    createBootstrapError() {
        return new Vue({
            el: '#app',
            render(createElement) {
                return createElement('div', {
                    'class': 'erro-inicializacao'
                }, [
                    createElement('div', {}, [
                        createElement('i', {
                            'class': 'far fa-surprise'
                        }),
                        createElement('p', 'Ocorreu um erro na inicialização desta aplicação.')
                    ])
                ])
            }
        })
    }
}

export default new RootPageCreator()